var styleDataHash = "86580a9e";
const injectCss = (() => {
  var css = `.zPb14{white-space:nowrap}.zPb14>:not(hr){flex-shrink:0}.zPb14 hr{height:unset;margin-inline:6px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var preset_bar_default = {
  "root": "zPb14"
};
export {
  preset_bar_default as default,
  injectCss
};
//# sourceMappingURL=preset-bar-scss.js.map
